<div class="row d-flex justify-content-center modalWrapper">
    <ejs-dialog
        #confirmationDelete
        [buttons]="buttonsDelete"
        [content]="'Opravdu chcete deautorizovat tohoto uživatele?'"
        [header]="'Deautorizovat uživatele'"
        [isModal]="true"
        [showCloseIcon]="true"
        [visible]="false"
        width="400px"
    ></ejs-dialog>
    <ejs-dialog
        #confirmationReset
        [buttons]="buttonsReset"
        [content]="'Opravdu chcete resetovat heslo tohoto uživatele?'"
        [header]="'Resetovat heslo uživatele'"
        [isModal]="true"
        [showCloseIcon]="true"
        [visible]="false"
        width="400px"
    ></ejs-dialog>
    <ejs-dialog
        #confirmationAuthorized
        [buttons]="buttonsAuthorized"
        [content]="'Opravdu chcete re-autorizovat tohoto uživatele?'"
        [header]="'RE-Autorizovat uživatele'"
        [isModal]="true"
        [showCloseIcon]="true"
        [visible]="false"
        width="400px"
    ></ejs-dialog>
    <ejs-dialog
        #passwordWarning
        [header]="'Upozornění zabezpečení!'"
        [height]="'500px'"
        [isModal]="true"
        [showCloseIcon]="true"
        [visible]="false"
        [width]="'85%'"
        id="passwordWarning"
    >
        <ng-template #content>
            <div class="dialogContent">
                <h3>Vaše heslo není bezpečené!</h3>
                <div class="col-12">
                    <p>Přejděte na svůj profil a pokračujte změnou hesla.</p>
                </div>
                <div class="col-12 mb-5 text-center">
                    <small class="text-muted"
                        >tlačítko pro změnu hesla vypadá takto:</small
                    >
                    <button
                        class="e-btn e-primary btn-p-zero e-small col-12"
                        ejs-button
                    >
                        <i aria-hidden="true" class="fa-light fa-user-lock"></i>
                    </button>
                </div>
                <div class="col-12">
                    <p>
                        <strong
                            ><u>Důležité!!</u> Aktualizujte si svoje telefonní
                            číslo na svých profilech pomocí formuláře v pravé
                            části, políčko:
                            <i><u>"pracovní telefon"</u></i></strong
                        >
                    </p>
                </div>
            </div>
        </ng-template>
        <ng-template #footerTemplate>
            <div class="d-flex justify-content-end">
                <button
                    (click)="passwordWarning.hide()"
                    [routerLink]="['/users/detail/', currentUser.id]"
                    cssClass="e-btn e-warning btn-p-zero e-small"
                    ejs-button
                >
                    Aktualizovat profil
                </button>
                <button
                    (click)="passwordWarning.hide()"
                    cssClass="e-btn e-danger e-outline btn-p-zero e-small"
                    ejs-button
                    type="button"
                >
                    ZRUŠIT
                </button>
            </div>
        </ng-template>
    </ejs-dialog>
    <app-user-edit-password-form
        (passwordEditFormDialogState)="renderChangeUserPassword = $event"
        [isVisible]="renderChangeUserPassword"
        [user]="user"
    ></app-user-edit-password-form>
    <app-user-form
        (userFormDialogState)="
            renderUserFormDialog = $event;
            isCreate = $event;
            isUpdate = $event;
            isCopy = $event
        "
        [isCopy]="isCopy"
        [isCreate]="isCreate"
        [isUpdate]="isUpdate"
        [isVisible]="renderUserFormDialog"
        [user]="user && (isUpdate || isCopy) ? user : null"
    ></app-user-form>
</div>
<div class="row my-2">
    <ng-container *ngIf="user && !loadingUser">
        <div class="col-12 col-md-3">
            <div class="e-card">
                <div class="e-card-header">
                    <div class="avatar w-25">
                        <input
                            #fileInput
                            (change)="onFileChanged($event)"
                            accept="image/*"
                            style="display: none"
                            type="file"
                        />
                        <div class="view overlay zoom">
                            <img
                                alt="profilový obrázek"
                                class="img-fluid rounded-circle hoverable"
                                src="assets/img{{ user.personalphoto }}"
                            />
                            <div class="mask flex-center rgba-black-light">
                                <p
                                    (click)="fileInput.click()"
                                    class="white-text"
                                    >vyměnit</p
                                >
                            </div>
                        </div>
                    </div>
                </div>
                <div class="e-card-content text-center">
                    <h5 class="pb-2 m-0 text-black-imp font-weight-bold">{{
                        user.fullname
                    }}</h5>
                    <h6 class="pb-1 m-0 text-black-imp">{{
                        user.official_position_name
                    }}</h6>
                    <ul class="list-group list-group-flush mb-2">
                        <li class="list-group-item p-2">
                            <div class="d-flex justify-content-center">
                                <strong *ngIf="user" class="col-4">
                                    <i
                                        *ngIf="user.authorized"
                                        aria-hidden="true"
                                        class="fa-light fa-user-check text-success mr-1"
                                        title="autorizovaný"
                                    ></i>
                                    <i
                                        *ngIf="!user.authorized"
                                        aria-hidden="true"
                                        class="fa-light fa-user-times text-danger mr-1"
                                        title="de-autorizovaný"
                                    ></i>
                                </strong>
                                <strong *ngIf="user" class="col-4">
                                    <i
                                        *ngIf="user.emailverify"
                                        aria-hidden="true"
                                        class="fa-light fa-envelope-open text-success mr-1"
                                        title="email ověřen"
                                    ></i>
                                    <i
                                        *ngIf="!user.emailverify"
                                        aria-hidden="true"
                                        class="fa-light fa-envelope text-danger mr-1"
                                        title="email není ověřen"
                                    ></i>
                                </strong>
                            </div>
                        </li>
                        <li class="list-group-item p-2">
                            <small>
                                <strong class="text-muted">
                                    <i
                                        aria-hidden="true"
                                        class="fa-light fa-mobile mr-1"
                                    ></i>
                                    <a href="tel:{{ user.telnumber }}">{{
                                        user.telnumber
                                    }}</a>
                                </strong>
                            </small>
                            <br />
                            <small>
                                <strong class="text-muted">
                                    <i
                                        aria-hidden="true"
                                        class="fa-light fa-envelope mr-1"
                                    ></i>
                                    <a href="mailto:{{ user.workemail }}">{{
                                        user.workemail
                                    }}</a>
                                </strong>
                            </small>
                        </li>
                    </ul>
                    <ul class="list-group list-group-flush mb-2">
                        <li
                            *ngIf="user.employer"
                            class="list-group-item text-black-imp"
                        >
                            <strong>zaměstnavatel:</strong><br />
                            {{ user.employer.name }}
                        </li>
                        <li
                            *ngIf="user.boss"
                            class="list-group-item text-black-imp"
                        >
                            <strong>nadřízený:</strong><br />
                            {{ user.boss.firstname }}&nbsp;{{
                                user.boss.secondname
                            }}
                        </li>
                        <li
                            *ngIf="
                                user.assignations &&
                                user.assignations.length > 0
                            "
                            class="list-group-item text-black-imp"
                        >
                            <strong>role:</strong><br />
                            <ul class="list-group">
                                <li
                                    *ngFor="
                                        let assignation of user.assignations
                                    "
                                    class="list-group-item"
                                >
                                    <small *ngIf="assignation.department">
                                        {{
                                            assignation.department.company.name
                                        }}
                                        / {{ assignation.department.name }} /
                                        {{ assignation.role.name }}
                                    </small>
                                </li>
                            </ul>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="col-12 col-md-9">
            <div
                aria-label="Profilová nástrojová lišta"
                class="d-flex justify-content-end"
                role="toolbar"
            >
                <div class="col-12 text-md-right text-center">
                    <div
                        aria-label="conatct"
                        class="e-btn-group m-2"
                        role="group"
                    >
                        <a
                            href="mailto:{{ user.workemail }}"
                            title="napsat email"
                        >
                            <button
                                cssClass="e-btn e-primary btn-p-zero e-small"
                                ejs-button
                            >
                                <i
                                    aria-hidden="true"
                                    class="fa-light fa-envelope mr-1"
                                ></i
                                ><span class="d-none d-lg-inline"
                                    >napsat e-mail</span
                                >
                            </button>
                        </a>
                        <a href="tel:{{ user.telnumber }}" title="zavolat">
                            <button
                                cssClass="e-btn e-primary btn-p-zero e-small"
                                ejs-button
                            >
                                <i
                                    aria-hidden="true"
                                    class="fa-light fa-mobile mr-1 d-sm-inline"
                                ></i
                                ><span class="d-none d-lg-inline">volat</span>
                            </button>
                        </a>
                    </div>
                    <div
                        aria-label="actions"
                        class="e-btn-group m-2"
                        role="group"
                    >
                        <button
                            (click)="editUser()"
                            *ngIf="
                                user.authorized &&
                                (user.id === currentUser.id ||
                                    user.boss_id === currentUser.id ||
                                    (currentUser.rule &&
                                        (currentUser.rule.is_administrative ||
                                            currentUser.rule.is_admin)))
                            "
                            cssClass="e-btn e-warning btn-p-zero e-small"
                            ejs-button
                            title="upravit uživatele"
                        >
                            <i
                                aria-hidden="true"
                                class="fa-light fa-user-edit mr-1"
                            ></i
                            ><span class="d-none d-lg-inline">upravit</span>
                        </button>
                        <button
                            (click)="confirmationDelete.show()"
                            *ngIf="
                                user.authorized &&
                                (user.boss_id === currentUser.id ||
                                    (currentUser.rule &&
                                        (currentUser.rule.is_administrative ||
                                            currentUser.rule.is_admin)))
                            "
                            cssClass="e-btn e-danger btn-p-zero e-small"
                            ejs-button
                            title="deautorizuje uživatele"
                        >
                            <i
                                aria-hidden="true"
                                class="fa-light fa-user-times mr-1"
                            ></i
                            ><span class="d-none d-lg-inline"
                                >de-autorizovat</span
                            >
                        </button>
                        <button
                            (click)="confirmationAuthorized.show()"
                            *ngIf="
                                !user.authorized &&
                                (user.boss_id === currentUser.id ||
                                    (currentUser.rule &&
                                        (currentUser.rule.is_administrative ||
                                            currentUser.rule.is_admin)))
                            "
                            cssClass="e-btn e-success btn-p-zero e-small"
                            ejs-button
                            title="autorizuje uživatele"
                        >
                            <i
                                aria-hidden="true"
                                class="fa-light fa-user-plus mr-1"
                            ></i
                            ><span class="d-none d-lg-inline"
                                >re-autorizovat</span
                            >
                        </button>
                        <button
                            (click)="changePassword()"
                            *ngIf="currentUser.id === user.id"
                            class="e-btn e-primary btn-p-zero e-small"
                            ejs-button
                            title="změnit heslo uživatele"
                        >
                            <i
                                aria-hidden="true"
                                class="fa-light fa-user-lock mr-1"
                            ></i
                            ><span class="d-none d-lg-inline"
                                >změnit heslo</span
                            >
                        </button>
                        <button
                            (click)="confirmationReset.show()"
                            *ngIf="
                                user.authorized &&
                                (user.boss_id === currentUser.id ||
                                    (currentUser.rule &&
                                        (currentUser.rule.is_administrative ||
                                            currentUser.rule.is_admin)))
                            "
                            cssClass="e-btn e-warning btn-p-zero e-small"
                            ejs-button
                            title="resetovat heslo uživatele"
                        >
                            <i
                                aria-hidden="true"
                                class="fa-light fa-lock mr-1"
                            ></i
                            ><span class="d-none d-lg-inline"
                                >resetovat heslo</span
                            >
                        </button>
                    </div>
                </div>
            </div>
            <hr class="mb-2" />
            <div class="row mb-2">
                <div class="col-12">
                    <div class="e-card"> </div>
                </div>
            </div>
        </div>
    </ng-container>
    <ng-container *ngIf="loadingUser || !user">
        <div class="col-12 col-md-3 col-lg-2">
            <div class="row">
                <div class="col-12 mb-1 text-center">
                    <div class="e-card">
                        <div class="e-card-content">
                            <app-loader></app-loader>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-md-9 col-lg-10">
            <div class="row">
                <div class="col-12 mb-1 text-center">
                    <div class="e-card">
                        <div class="e-card-content">
                            <app-loader></app-loader>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-container>
</div>
